/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cinematic_ExpositionInputs */

const en_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinematic Exposition`)
};

const es_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposición cinematográfica`)
};

const fr_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposition cinématique`)
};

const de_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filmische Exposition`)
};

const ja_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シネマティックな説明`)
};

const zh_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沉浸式品牌介绍`)
};

const ar_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصف السينمائي (مقدمة)`)
};

const id_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksposisi Sinematik`)
};

const it_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esposizione Cinematografica`)
};

const ru_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кинематографичная экспозиция`)
};

const pt_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposição Cinematográfica`)
};

const ko_cinematic_exposition = /** @type {(inputs: Cinematic_ExpositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시네마틱 소개 문구`)
};

/**
* | output |
* | --- |
* | "Cinematic Exposition" |
*
* @param {Cinematic_ExpositionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const cinematic_exposition = /** @type {((inputs?: Cinematic_ExpositionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cinematic_ExpositionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cinematic_exposition(inputs)
	if (locale === "es") return es_cinematic_exposition(inputs)
	if (locale === "fr") return fr_cinematic_exposition(inputs)
	if (locale === "de") return de_cinematic_exposition(inputs)
	if (locale === "ja") return ja_cinematic_exposition(inputs)
	if (locale === "zh") return zh_cinematic_exposition(inputs)
	if (locale === "ar") return ar_cinematic_exposition(inputs)
	if (locale === "id") return id_cinematic_exposition(inputs)
	if (locale === "it") return it_cinematic_exposition(inputs)
	if (locale === "ru") return ru_cinematic_exposition(inputs)
	if (locale === "pt") return pt_cinematic_exposition(inputs)
	return ko_cinematic_exposition(inputs)
});